import { render, staticRenderFns } from "./UiMarketProduct.vue?vue&type=template&id=322c5d18&"
import script from "./UiMarketProduct.vue?vue&type=script&lang=js&"
export * from "./UiMarketProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports